/* eslint-disable react/prop-types */
import React from 'react';
import styled, { withTheme } from 'styled-components';
import Icon from '@ntuctech/devex-tangram/Icon';

const LoaderSC = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.2);
`;

function Loader({ theme }) {
  const { ColorFontPrimary } = theme;
  return (
    <LoaderSC>
      <Icon name="loading" size="l" color={ColorFontPrimary} />
    </LoaderSC>
  );
}

export default withTheme(Loader);
